import * as React from "react";
import { Link } from "../../atoms/Link";
import appStoreBadge from "../../../images/app-store-badge.png";
import googlePlayBadge from "../../../images/google-play-badge.png";
import logo from "../../../images/logo.svg";
import { BlueskyIcon, EmailIcon, LinkedInIcon, XIcon } from "../icons";
import {
  blogPath,
  infoPath,
  LANG_FR_FR,
  pressPath,
  requestADemoPath,
} from "../../../constants";

const locale = LANG_FR_FR;

const navigation = {
  solutions: [
    { name: "Téléexpertise", href: "/teleexpertise" },
    { name: "e-RCP", href: "/RCP" },
    { name: "Téléconsultation", href: "/teleconsultation" },
  ],
  company: [
    { name: "Actualités", href: blogPath({ locale }) },
    { name: "Presse", href: pressPath({ locale }) },
    {
      name: "On recrute !",
      href: "https://www.welcometothejungle.com/fr/companies/omnidoc",
    },
    { name: "Tarifs", href: "/tarifs" },
    { name: "FAQ", href: infoPath({ locale }) },
  ],
  legal: [
    { name: "CGU", href: "/cgu" },
    { name: "Mentions légales", href: "/mentions-legales" },
    { name: "Données personnelles", href: "/donnees-personnelles" },
  ],
  contact: [
    { name: "Demander une démo", href: requestADemoPath(LANG_FR_FR) },
    { name: "contact@omnidoc.fr", href: "mailto:contact@omnidoc.fr" },
  ],
  social: [
    {
      name: "Linkedin",
      href: "https://www.linkedin.com/company/omnidocapp",
      icon: LinkedInIcon,
    },
    {
      name: "Bluesky",
      href: "https://bsky.app/profile/did:plc:z34pritos7y5pammf3doztb7",
      icon: BlueskyIcon,
    },
    {
      name: "X",
      href: "https://x.com/omnidoc_app",
      icon: XIcon,
    },
    {
      name: "Email",
      href: "mailto:contact@omnidoc.fr",
      icon: EmailIcon,
    },
  ],
};

export const Footer = (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="xl:grid xl:grid-cols-3 xl:gap-8">
      <div className="space-y-8 xl:col-span-1">
        <img
          className="h-4 w-auto sm:h-4 mb-0"
          src={logo}
          alt="Omnidoc, plateforme de télé-expertise"
        />
        <p className="text-gray-500 text-base max-w-prose">
          Omnidoc est une société indépendante créée en 2019 et entièrement
          dédiée au développement de sa solution de collaboration médicale et
          à sa prise en main par les professionnels de santé.
        </p>
        <div className="flex space-x-6">
          {navigation.social.map(item => (
            <Link
              key={item.name}
              to={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-5 w-5" aria-hidden="true" />
            </Link>
          ))}
        </div>
        <div className="flex -mx-2 max-w-sm">
          <a
            className="h-10 w-auto mx-2"
            href="https://apps.apple.com/fr/app/omnidoc/id1532875565"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="max-h-full"
              src={appStoreBadge}
              alt="Télécharger l'application mobile pour iPhone"
            />
          </a>
          <a
            className="h-10 w-auto mx-2"
            href="https://play.google.com/store/apps/details?id=fr.omnidoc.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="max-h-full"
              src={googlePlayBadge}
              alt="Télécharger l'application mobile pour Android"
            />
          </a>
        </div>
      </div>
      <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
        <div className="md:grid md:grid-cols-2 md:gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Solutions
            </h3>
            <ul className="mt-4 space-y-4">
              {navigation.solutions.map(item => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-500 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-12 md:mt-0">
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Confidentialité
            </h3>
            <ul className="mt-4 space-y-4">
              {navigation.legal.map(item => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-500 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="md:grid md:grid-cols-2 md:gap-8">
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Plus sur Omnidoc
            </h3>
            <ul className="mt-4 space-y-4">
              {navigation.company.map(item => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-500 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-12 md:mt-0">
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Nous contacter
            </h3>
            <ul className="mt-4 space-y-4">
              {navigation.contact.map(item => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-500 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);
